import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

const STORAGE_KEY = "boscage_shipping_location";

// Boscage ships North America only — per /shipping policy.
const COUNTRIES = [
  { code: "US", label: "United States", currency: "USD" },
  { code: "CA", label: "Canada", currency: "USD" },
  { code: "MX", label: "Mexico", currency: "USD" },
];

export default function WelcomeLocationModal() {
  const [open, setOpen] = useState(false);
  const [country, setCountry] = useState(COUNTRIES[0].code);

  useEffect(() => {
    const saved = typeof window !== "undefined" && window.localStorage.getItem(STORAGE_KEY);
    if (!saved) setOpen(true);
  }, []);

  const confirm = () => {
    const picked = COUNTRIES.find((c) => c.code === country) || COUNTRIES[0];
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...picked, confirmed_at: new Date().toISOString() }),
    );
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      data-testid="welcome-location-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="welcome-location-title"
      className="fixed inset-0 z-[9999] flex items-center justify-center px-4"
    >
      {/* Backdrop with blur */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-md" />

      {/* Card */}
      <div
        className="relative w-full max-w-[520px] bg-[#0f0f0f] text-white p-8 md:p-10 border border-white/10"
        data-testid="welcome-location-card"
      >
        <h2
          id="welcome-location-title"
          className="font-serif text-2xl md:text-3xl text-center text-white"
        >
          Welcome to BOSCAGE
        </h2>
        <p className="mt-3 text-center text-sm text-white/65 leading-relaxed">
          Please confirm your shipping location to continue to our online store.
        </p>

        <div className="mt-8">
          <label
            htmlFor="welcome-country"
            className="text-[10px] tracking-[0.28em] uppercase text-white/50 block mb-2"
          >
            Country
          </label>
          <div className="relative">
            <select
              id="welcome-country"
              data-testid="welcome-country-select"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              className="w-full appearance-none bg-transparent border border-white/25 text-white text-sm tracking-wide uppercase px-4 py-3.5 pr-10 focus:outline-none focus:border-[#c9a84c] cursor-pointer"
            >
              {COUNTRIES.map((c) => (
                <option
                  key={c.code}
                  value={c.code}
                  className="bg-[#0f0f0f] text-white"
                >
                  {c.label.toUpperCase()} — {c.currency}
                </option>
              ))}
            </select>
            <ChevronDown
              size={16}
              strokeWidth={1.5}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-white/60 pointer-events-none"
            />
          </div>
        </div>

        <button
          type="button"
          onClick={confirm}
          data-testid="welcome-confirm-button"
          className="mt-4 w-full bg-white text-black text-[11px] tracking-[0.28em] uppercase py-4 hover:bg-[#c9a84c] transition-colors"
        >
          Confirm Shipping Location
        </button>

        <p className="mt-6 text-center text-[10px] tracking-[0.22em] uppercase text-white/40">
          BOSCAGE ships to USA · Canada · Mexico only
        </p>
      </div>
    </div>
  );
}
